import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { FlowProvider, useFlow } from "@/context/FlowContext";
import { track } from "@/api";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { QueNecesitas } from "@/components/QueNecesitas";
import { AsiDeFacil } from "@/components/AsiDeFacil";
import { Confianza } from "@/components/Confianza";
import { Profesionales } from "@/components/Profesionales";
import { MadridSection, CTAFinal } from "@/components/Closing";
import { VerifiedTeaser } from "@/components/VerifiedTeaser";
import { Footer } from "@/components/Footer";
import { RequestWizard } from "@/components/RequestWizard";
import { ProfessionalWizard } from "@/components/ProfessionalWizard";
import { ReviewModal } from "@/components/ReviewModal";
import { ChatWidget } from "@/components/ChatWidget";
import Admin from "@/pages/Admin";
import { ProfessionalsDirectory, ProfessionalProfile } from "@/pages/ProfessionalsPublic";
import LegalPage from "@/pages/LegalPage";

const ReviewLauncher = () => {
  const [params, setParams] = useSearchParams();
  const { openReview } = useFlow();
  useEffect(() => {
    const ref = params.get("review");
    if (ref) { openReview(ref); const p = new URLSearchParams(params); p.delete("review"); setParams(p, { replace: true }); }
  }, [params, openReview, setParams]);
  return null;
};

const Landing = () => {
  useEffect(() => { track("page_view", "landing"); }, []);
  return (
    <div className="App bg-white text-ink font-body">
      <ReviewLauncher />
      <Navbar />
      <main>
        <Hero />
        <QueNecesitas />
        <AsiDeFacil />
        <Confianza />
        <Profesionales />
        <VerifiedTeaser />
        <MadridSection />
        <CTAFinal />
      </main>
      <Footer />
      <RequestWizard />
      <ProfessionalWizard />
      <ReviewModal />
      <ChatWidget />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <LanguageProvider>
        <FlowProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/profesionales" element={<ProfessionalsDirectory />} />
            <Route path="/profesional/:id" element={<ProfessionalProfile />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacidad" element={<LegalPage />} />
            <Route path="/terminos" element={<LegalPage />} />
            <Route path="/cookies" element={<LegalPage />} />
          </Routes>
        </FlowProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
